import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { fromDesignComponentActions } from './design-component.action';

@Injectable()
export class DesignComponentEffects {
  triggerSaveDesignComponents$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        fromDesignComponentActions.AddDesignComponent,
        fromDesignComponentActions.UpdateDesignComponent,
        fromDesignComponentActions.DesignComponentConfigurationChange,
        fromDesignComponentActions.DeleteDesignComponent,
        fromDesignComponentActions.DeleteDesignComponentSuccess,
        fromDesignComponentActions.DeleteDesignComponentFromStore
      ),
      mergeMap(() => {
        return [fromDesignComponentActions.SaveDesignComponents()];
      })
    )
  );

  constructor(private actions$: Actions) {}
}
